import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IDocumentType } from '../../../message-models/document-type.interface';
import { DynamicDialogRef } from "primeng/dynamicdialog";
import { IEntityDocumentSummary } from '../../../message-models/entity-document-summary';
import { EntityDocumentSummary } from '../../../message-models/entity-document-summary.class';
import { consts } from '../../../common/modals/consts';
import { HelpConsts } from "../../../help/models/help-consts";

@Component({
  selector: 'app-document-uploader-modal',
  templateUrl: './document-uploader-modal.component.html',
  styleUrls: ['./document-uploader-modal.component.scss']
})

export class DocumentUploaderModalComponent implements OnInit {

  defaultFileName: string;
  private loading: boolean;
  isNewDocument = false;

  @Input() documentTypes: IDocumentType[];
  @Input() isEditing = false;
  @Input() entityDocumentSummary: IEntityDocumentSummary;
  documentUploadRequest: FormData;
  @Input() headerText = 'Upload Document';
  @Output() documentUploadSave: EventEmitter<FormData> = new EventEmitter<FormData>();
  @Output() cancelClicked: EventEmitter<void> = new EventEmitter<void>();
  tempDocumentSummary: IEntityDocumentSummary;
  formIsValid = false;
  saveAttempted: boolean = false;
  showingHelp: boolean = false;
  helpText: string = HelpConsts.DocumentsEntryHelp.sections[0].body;

  constructor(public modalRef: DynamicDialogRef) { }

  ngOnInit(): void {
    this.initDocumentUploadForm();
  }

  initDocumentUploadForm() {
    this.documentUploadRequest = new FormData();
    if (this.entityDocumentSummary && this.entityDocumentSummary?.documentId !== consts.emptyGuid && this.entityDocumentSummary?.documentId != null) {
      this.tempDocumentSummary = new EntityDocumentSummary(this.entityDocumentSummary);
      this.defaultFileName = this.entityDocumentSummary.originalFilename;
    } else {
      this.isEditing = true;
      this.isNewDocument = true;
      this.tempDocumentSummary = new EntityDocumentSummary(this.entityDocumentSummary);
    }
  }

  

  getSelectedDocumentType(documentTypeId: string): IDocumentType {
    return this.documentTypes.find(t => t.id === documentTypeId);
  }

  saveClicked() {
    this.saveAttempted = true;
    if (!this.tempDocumentSummary?.documentTypeId || !this.tempDocumentSummary?.documentCreationDate?.dateTime || !this.tempDocumentSummary?.originalFilename ||
      (!this.tempDocumentSummary?.extraDescription && this.getSelectedDocumentType(this.tempDocumentSummary?.documentTypeId)?.name === "Other")) {
      return false;
    }

    this.saveAttempted = false;

    this.documentUploadRequest.append('DocumentId', this.tempDocumentSummary.documentId);
    this.documentUploadRequest.append('DocumentTypeId', this.tempDocumentSummary.documentTypeId);
    this.documentUploadRequest.append('ExtraDescription', this.tempDocumentSummary.extraDescription);
    this.documentUploadRequest.append('OriginalFilename', this.tempDocumentSummary.originalFilename);
    if (this.tempDocumentSummary.reviewDate.dateTime) {
      this.documentUploadRequest.append('DocumentReviewDate', this.tempDocumentSummary.reviewDate.dateTime);
    }
    if (this.tempDocumentSummary.expiryDate.dateTime) {
      this.documentUploadRequest.append('DocumentExpiryDate', this.tempDocumentSummary.expiryDate.dateTime);
    }
    this.documentUploadRequest.append('DocumentCreationDate', this.tempDocumentSummary.documentCreationDate.dateTime);
    this.documentUploadSave.emit(this.documentUploadRequest);
  }

  helpClicked() {
    this.showingHelp = !this.showingHelp;
  }

  cancelBtnClicked() {
    if (this.isNewDocument) {
      this.modalRef.close();
      this.cancelClicked.emit();
    } else {
      this.isEditing = false;
    }
  }

  fileUploaded(file: File) {
    if (file) {
      this.documentUploadRequest.append('FormFile', file, file.name);
    } else {
      this.formIsValid = false;
    }
  }

  removeFile(remove: boolean) {
    if (remove) {
      this.documentUploadRequest.delete('FormFile');
      this.formIsValid = false;
    }
  }

  canSaveDocument(canSave: any) {
    this.formIsValid = canSave;
  }

  editClicked() {
    this.isEditing = true;
  }
}
